import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '../common/Card';
import Typography from '@mui/material/Typography';
import { SectionSubheading } from '../common/styled/SectionHeading';

interface LubricationInfo {
  vessel: string;
  manager: string;
  lastUpdatedBy: string;
  lastUpdatedOn: string;
}

interface LubricationDetailsInformationProps {
  lubricationInfo: LubricationInfo;
  onBack?: () => void;
  mode?: 'view' | 'edit';
}

const LubricationDetailsInformation: React.FC<LubricationDetailsInformationProps> = ({
  lubricationInfo,
  onBack: _onBack,
  mode: _mode,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Card>
      <Box sx={{ mb: 1.5, mt: -1.5 }}>
        <SectionSubheading>{t('common.lubricationInformation')}</SectionSubheading>
      </Box>

      {/* Custom divider that spans full width */}
      <Box
        sx={{
          height: '2px',
          backgroundColor: theme.palette.dropdown.border,
          mx: '-24px', // Negative margin to override card padding
          mb: 3,
        }}
      />

      <Grid container spacing={3}>
        {[
          { label: t('form.vessel'), value: lubricationInfo.vessel },
          { label: t('form.manager'), value: lubricationInfo.manager },
          { label: t('common.lastUpdatedBy'), value: lubricationInfo.lastUpdatedBy },
          { label: t('common.lastUpdatedOn'), value: lubricationInfo.lastUpdatedOn },
        ].map((item) => (
          <Grid size={{ xs: 12, sm: 3 }} key={item.label}>
            <Typography
              sx={{
                fontWeight: 500,
                color: theme.palette.modal.title,
                fontSize: '16px',
              }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.modal.title,
                fontSize: '14px',
                fontWeight: 400,
                mt: 1,
              }}
            >
              {item.value || '-'}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
};

export default LubricationDetailsInformation;
